import { type BaseApiErrorResponse, HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

export type NotFoundErrorArgs<TErrors> = Omit<
  BaseApiErrorResponse<TErrors>,
  'errors' | 'status'
>;
export default class NotFoundError<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  constructor({ code, message }: NotFoundErrorArgs<TErrors>) {
    super({ code, errors: null, message, status: HttpStatus.NotFound });
  }
}
